import * as authServices from '@/services/authServices';
import * as userServices from '@/services/userServices';
import * as doronServices from '@/services/doronServices';

export default {
  async createUser({ commit }, payload) {
    const uid = authServices.getUID();
    // upload photo file and get this url
    const photoURL = await userServices.uploadUserPhotoAndGetItsStoragePath(
      uid,
      payload.photoFile
    );

    // update user doc
    const userDoc = {
      nickname: payload.nickname,
      birthDate: payload.birthDate,
      userType: payload.userType,
      categories: [],
      selfIntroduction: '',
      // アクションで受け取ったpayloadにphotoFileがない場合は、defaultPhotoUrlを送信。
      photoURL: photoURL || payload.defaultPhotoUrl,
      isStreaming: false,
      ivsChannelArn: '',
      ivsStreamKeyArn: '',
      recentLiveId: ''
    };
    try {
      await userServices.createUserDoc(uid, userDoc);
    } catch (err) {
      console.error(err);
      return;
    }

    // init doron doc
    await doronServices.updateDoronDoc(uid, {
      freeAmount: 500,
      amount: 0
    });

    // update state
    // TODO: とってこれるなら、payloadじゃなくてレスポンスから入れたほうがいいかも。
    commit('auth/onAuthStateChanged', {
      uid: uid,
      email: payload.email
    });
    commit('user/loadUserDoc', userDoc);

    await authServices
      .getFirebaseUser()
      .sendEmailVerification()
      .catch(err => {
        alert(
          '[Error] Can not send mail',
          `${
            authServices.getFirebaseUser().email
          }宛に確認メールを送信できませんでした: ${err}`
        );
      });
  }
};
